import controller from './login-dialog.controller';

export default {
  controller,
  template: require('./login-dialog.html')
};



// WEBPACK FOOTER //
// src/app/components/login-dialog/login-dialog.component.ts